import { ArrowRightIcon } from '@heroicons/react/24/solid'
import type { E164Number } from 'libphonenumber-js/core'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import LoaderIcon from '~/src/components/svg/LoaderIcon'
import { DUPE_SUPPORTED_COUNTRIES_MAPPING } from '~/src/lib/constants'
import { cn } from '~/src/lib/utils'

interface PhoneInputWrapperProps {
  phoneNumber: E164Number
  setPhoneNumber: (value: E164Number) => void
  onSubmit: () => void
  processing: boolean
  validNumber: boolean
}

const DUPE_SUPPORTED_COUNTRIES = Object.keys(
  DUPE_SUPPORTED_COUNTRIES_MAPPING || {}
).map((country) => country.toUpperCase())

const PhoneInputWrapper: React.FC<PhoneInputWrapperProps> = ({
  phoneNumber,
  setPhoneNumber,
  onSubmit,
  processing,
  validNumber,
}) => {
  return (
    <div className='flex w-full items-center overflow-hidden rounded-full border border-black/10 bg-white/30'>
      <PhoneInput
        value={phoneNumber}
        international
        defaultCountry='US'
        countryOptionsOrder={DUPE_SUPPORTED_COUNTRIES as any}
        countries={DUPE_SUPPORTED_COUNTRIES as any}
        countryCallingCodeEditable={false}
        numberInputProps={{
          className:
            'w-full px-1 py-2 !bg-transparent text-black dark:text-white',
        }}
        className={cn(
          'flex h-16 flex-1 pl-5 font-mono text-xl text-black dark:text-white',
          {
            'border-red-500':
              !validNumber && !!phoneNumber && phoneNumber?.length > 3,
          }
        )}
        initialValueFormat='national'
        onChange={(value) => setPhoneNumber(value as E164Number)}
        onKeyDown={(e: any) => {
          if (e.key === 'Enter') {
            onSubmit()
          }
        }}
      />

      <button
        className={cn(
          'mr-2 flex aspect-square h-12 w-12 items-center justify-center rounded-full bg-black transition-opacity',
          {
            'opacity-0': !phoneNumber || !validNumber,
            'opacity-100': phoneNumber && validNumber,
          }
        )}
        onClick={onSubmit}
      >
        {processing ? (
          <div className='animate-spin text-white'>
            <LoaderIcon height={32} />
          </div>
        ) : (
          <ArrowRightIcon className='h-5 w-5 text-white' />
        )}
      </button>
    </div>
  )
}

export default PhoneInputWrapper
